import "core-js/modules/es6.array.map";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
export var LanguageMapper =
/*#__PURE__*/
function () {
  function LanguageMapper() {
    _classCallCheck(this, LanguageMapper);
  }

  _createClass(LanguageMapper, [{
    key: "mapMultipleLanguages",
    value: function mapMultipleLanguages(response) {
      var _this = this;

      return response.languages.map(function (language) {
        return _this.mapLanguage(language);
      });
    }
  }, {
    key: "mapLanguage",
    value: function mapLanguage(language) {
      if (!language) {
        throw Error("Cannot map language");
      }

      return {
        system: language.system
      };
    }
  }]);

  return LanguageMapper;
}();